<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose, defineProps, reactive, onMounted } from 'vue';
    import axios from 'axios';
    import MarketAttributsFormModal from './MarketAttributsFormModal.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';

    const props = defineProps({});
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const formModalRef = ref<InstanceType<typeof MarketAttributsFormModal> | null>(null);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItem = ref(null as any);

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/market-attributs/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    async function open() {
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        selectedItem.value = null;
        doListItems();
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function onConfirm() {
        if (!selectedItem.value) { return; }
        resolvePromise(selectedItem.value);
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    async function doDeleteItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Attributs Market", "Voulez-vous vraiment supprimer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/market-attributs/destroy/${item.guid}`, {});
                const index = itemsList.value.findIndex(i => i.guid == item.guid);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function openFormModal(item?: any) {
        const result = await formModalRef.value?.open(item);
        if (result) { doListItems(); }
    }

    function onItemSelected(item: any) {
        selectedItem.value = item;
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" @closed="onClose" :classesNames="'modal-lg'">
        <template #header>
            <div style="flex: 1; display: flex; flex-direction:row; justify-content: space-between;">
                <h4 class="font-semibold">Attributs</h4>
                <button class="btn-ultra white2 tips" style="border: none;background: none;font-size: 1.2rem;" @click="openFormModal">
                    <div class="btn-show">
                        <img src="/icons/icon-add.svg" class="btn-icon" alt="" />
                        <span>Ajouter</span>
                    </div>
                </button>
            </div>
        </template>
        <div>
            <section class="s20">
                <div class="widget shadow-100 pb-2"><!-- widget shadow-100 fill -->
                    <!--Card-->
                    <div>
                        <table class="table separator skin1 selection"><!-- selection skin1 skin2 (bg1 bg2 bg3)  (skin3 rounded)  -->
                            <thead>
                                <tr>
                                    <th></th>
                                    <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Libellé</th>
                                    <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Enumérations</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="itemsList.length == 0">
                                    <tr>
                                        <td colspan="4">
                                            <div class="text-center text-grey-700">Aucun élément trouvé</div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="itemsList.length > 0">
                                    <template v-for="(item, index) in itemsList" :key="'item_' + index">
                                        <tr class="text-grey-700 over-effect over-effect-scale" :class="{'active': selectedItem?.guid == item.guid }" @click="onItemSelected(item)"><!-- over-effect active-->
                                            <td class="selection-item">
                                                <label class="btn-circle" :for="'item_' + index"><input type="checkbox" name="selection[]" :id="'item_' + index" :checked="selectedItem?.guid == item.guid" /></label>
                                            </td>
                                            <td><h6>{{ item.nom }}</h6></td>
                                            <td><h6>{{ item.valeurs.join(', ') }}</h6></td>
                                            <td class="flex-right">
                                                <custom-button :classesList="'btn'" @click="openFormModal(item)">
                                                    <img src="/icons/icon-edit.svg" class="btn-icon" alt="" />
                                                    <span>Editer</span>
                                                </custom-button>
                                                <custom-button :classesList="'btn-ultra white2 tips'" @click="doDeleteItem(item)">
                                                    <img src="/icons/icon-delete.svg" class="btn-icon" alt="" />
                                                    <span>Supprimer</span>
                                                </custom-button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="clear-both h-30"></div>
                </div>
            </section>
            
            <div class="clear-both h-30"></div>
        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onConfirm" v-if="selectedItem">Valider</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Annuler</button>
        </template>
    </custom-modal>
    <market-attributs-form-modal ref="formModalRef" />
    <confirmation-modal ref="confirmationModalRef"></confirmation-modal>
</template>
